import { ADModalBody, ADModalFooter, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal"
import { GlassInputControl, GlassInputGroup, GlassInputGroupEscape, GlassInputGroupTitle, GlassTextInputTransformer } from "./GlassInput"
import { GlassButton } from "./GlassButtons"
import { Localization } from "@viamap/viamap2-common"
import { useState } from "react"
import { closeWindow, ManagedWindow } from "src/WindowManager/WindowState"
import { useWindowContext } from "src/WindowManager/useWindowContext"

type valueType = {
   "url": string,
   "desiredHeight": number,
   "offsetX": number,
   "offsetY": number
}

export function PlotLogoEditor(props:
   {
      managedWindow: ManagedWindow
      value?: valueType
      onChange(value: valueType): void
      default: valueType
      disabled?: boolean
   }): JSX.Element | null {

   const { dispatch: windowDispatch } = useWindowContext()
   const [lValue, setLValue] = useState<valueType>(props.value || props.default);

   function isValidUrl(url: string): boolean {
      if (url === "" || url === "default") {
         return true; // Allow empty or default value
      }
      try {
         new URL(url);
         return true;
      } catch {
         return false;
      }
   }

   return (
      <AdvancedDragModal window={props.managedWindow} title={"Plot Logo Editor"}
         onClose={() => windowDispatch(closeWindow(props.managedWindow.id))}
      >
         <ADModalBody>
            <GlassInputGroup>
               <GlassTextInputTransformer label={Localization.getText("Logo URL")}>
                  <GlassInputControl>
                     <input
                        type="text"
                        value={lValue.url || ""}
                        onChange={(e) => setLValue({ ...lValue, url: e.target.value })}
                        disabled={props.disabled}
                        className={isValidUrl(lValue.url) ? "" : "invalid"}
                        placeholder={Localization.getText("Logo URL")}
                     />
                  </GlassInputControl>
               </GlassTextInputTransformer>
               <GlassTextInputTransformer label={Localization.getText("Desired height")}>
                  <GlassInputControl>
                     <input
                        type="range"
                        value={lValue.desiredHeight || 0}
                        onChange={(e) => setLValue({ ...lValue, desiredHeight: Number(e.target.value) || 0, })}
                        disabled={props.disabled}
                        min={10 * 8}
                        max={50 * 8}
                     /><span>{Math.round((lValue.desiredHeight || 0) / 8)}mm</span>
                  </GlassInputControl>
               </GlassTextInputTransformer>
               <GlassTextInputTransformer label={Localization.getText("Offset X")}>
                  <GlassInputControl>
                     <input
                        type="range"
                        value={lValue.offsetX || 0}
                        onChange={(e) => setLValue({ ...lValue, offsetX: Number(e.target.value) || 0 })}
                        disabled={props.disabled}
                        min={-20 * 8}
                        max={20 * 8}
                     />
                     <span>{Math.round((lValue.offsetX || 0) / 8)}mm</span>
                  </GlassInputControl>
               </GlassTextInputTransformer>
               <GlassTextInputTransformer label={Localization.getText("Offset Y")}>
                  <GlassInputControl>
                     <input
                        type="range"
                        value={lValue.offsetY || 0}
                        min={-20 * 8}
                        max={20 * 8}
                        onChange={(e) => setLValue({ ...lValue, offsetY: Number(e.target.value) || 0 })}
                        disabled={props.disabled}
                     />
                     <span>{Math.round((lValue.offsetY || 0) / 8)}mm</span>
                  </GlassInputControl>
               </GlassTextInputTransformer>
               <GlassInputGroupTitle>{Localization.getText("Preview")}</GlassInputGroupTitle>
               <GlassInputGroupEscape>
                  <div style={{
                     background: "linear-gradient(-45deg, #f5f5f5, #eee0)", position: "relative", width: "80%", height: "120px", margin: "0 auto", padding: "10px",
                     borderRight: " 2px solid #ccc", borderBottom: "2px solid #ccc"
                  }}>
                     <img style={{
                        position: "absolute",
                        right: (lValue.offsetX || 0) / 8 + "mm",
                        bottom: (lValue.offsetY || 0) / 8 + "mm",
                        height: (lValue.desiredHeight || 0) / 8 + "mm"
                     }}
                        src={lValue.url.startsWith("http") ? lValue.url : "/Mapit/MapitLogoTissegul.svg"} alt="Logo Preview" />
                  </div>
               </GlassInputGroupEscape>
            </GlassInputGroup>
         </ADModalBody>
         <ADModalFooter>
            <GlassButton onClick={() => windowDispatch(closeWindow(props.managedWindow.id))} >{Localization.getText("Cancel")}</GlassButton>
            <GlassButton disabled={!isValidUrl(lValue.url)} onClick={() => { props.onChange(lValue); windowDispatch(closeWindow(props.managedWindow.id)) }} >{Localization.getText("Save")}</GlassButton>
         </ADModalFooter>
      </AdvancedDragModal>
   );
}